export const preventDefaultAndStopPropagation = (
  e: React.FocusEvent | React.MouseEvent
) => {
  e.stopPropagation()
  e.preventDefault()
}
